var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.isBusy && _vm.items.length === 0
      ? _c(
          "div",
          [
            _c("b-alert", { attrs: { variant: "info", show: "" } }, [
              _c("strong", [_vm._v("Hinweis:")]),
              _vm._v(
                " Es wurde noch keine Resteliste für diese Fahrt angelegt. Du kannst jetzt mit dem\n      Erstellen einer Resteliste beginnen. Wichtig: Du musst für alle Zeilen auf den Speichern-Button drücken,\n      sonst werden die eingegebenen Mengen nicht gespeichert!\n    "
              ),
            ]),
            _vm._v(" "),
            _c(
              "b-btn",
              {
                attrs: { variant: "primary", size: "lg" },
                on: {
                  click: function ($event) {
                    return _vm.loadDefaultList()
                  },
                },
              },
              [_vm._v("Resteliste erstellen")]
            ),
          ],
          1
        )
      : _c(
          "div",
          [
            !_vm.isBusy
              ? _c("b-alert", { attrs: { variant: "info", show: "" } }, [
                  _c("strong", [_vm._v("Wichtig:")]),
                  _vm._v(
                    " Die hier angegebenen Reste müssen dem Folgekurs auch auf jeden Fall zur Verfügung gestellt werden!\n    "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "clearfix" },
              [
                _c(
                  "b-btn",
                  {
                    staticClass: "float-right mb-2",
                    attrs: {
                      size: "sm",
                      variant: "outline-primary",
                      disabled: _vm.isBusy,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.fetchData()
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fas fa-sync-alt" }),
                    _vm._v(" Aktualisieren\n      "),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-table",
              {
                attrs: {
                  striped: "",
                  hover: "",
                  busy: _vm.isBusy,
                  items: _vm.filteredItems,
                  fields: _vm.fields,
                  "sort-compare": _vm.sortCompare,
                  stacked: "sm",
                  small: "",
                  bordered: "",
                  "head-variant": "dark",
                },
                on: {
                  "update:busy": function ($event) {
                    _vm.isBusy = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "cell(ingredient_title)",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c("RowButtonComponent", {
                          staticClass: "d-md-none float-right",
                          attrs: {
                            items: _vm.items,
                            item: item,
                            "api-url": _vm.apiUrl,
                            "can-edit": _vm.canEdit,
                          },
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(item.ingredient_title))]),
                      ]
                    },
                  },
                  {
                    key: "cell(amount_available)",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        !item._editing
                          ? _c("div", { staticClass: "float-right" }, [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatAmountNeeded(
                                      item.amount_available,
                                      null,
                                      item
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "d-md-none" }, [
                                _vm._v(_vm._s(item.base_unit_title)),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        item._editing
                          ? _c(
                              "b-input-group",
                              {
                                staticClass: "d-md-none",
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "append",
                                      fn: function () {
                                        return [
                                          _c(
                                            "b-input-group-text",
                                            { staticClass: "d-md-none" },
                                            [
                                              _vm._v(
                                                _vm._s(item.base_unit_title)
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c("b-form-input", {
                                  staticClass: "amount-input",
                                  attrs: {
                                    size: "sm",
                                    type: "number",
                                    step: Math.pow(
                                      10,
                                      item.base_unit_precision * -1
                                    ),
                                  },
                                  on: {
                                    keydown: [
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.$refs[
                                          "buttons"
                                        ].finishEditItem(item)
                                      },
                                      function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "esc",
                                            27,
                                            $event.key,
                                            ["Esc", "Escape"]
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.$refs[
                                          "buttons"
                                        ].cancelEditItem(item)
                                      },
                                    ],
                                  },
                                  model: {
                                    value: item._new_amount_available,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        item,
                                        "_new_amount_available",
                                        $$v
                                      )
                                    },
                                    expression: "item._new_amount_available",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        item._editing
                          ? _c("b-form-input", {
                              staticClass: "d-none d-md-block amount-input",
                              attrs: {
                                size: "sm",
                                type: "number",
                                step: Math.pow(
                                  10,
                                  item.base_unit_precision * -1
                                ),
                              },
                              on: {
                                keydown: [
                                  function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.$refs["buttons"].finishEditItem(
                                      item
                                    )
                                  },
                                  function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "esc",
                                        27,
                                        $event.key,
                                        ["Esc", "Escape"]
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.$refs["buttons"].cancelEditItem(
                                      item
                                    )
                                  },
                                ],
                              },
                              model: {
                                value: item._new_amount_available,
                                callback: function ($$v) {
                                  _vm.$set(item, "_new_amount_available", $$v)
                                },
                                expression: "item._new_amount_available",
                              },
                            })
                          : _vm._e(),
                      ]
                    },
                  },
                  {
                    key: "cell(actions)",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c("RowButtonComponent", {
                          ref: "buttons",
                          attrs: {
                            items: _vm.items,
                            item: item,
                            "api-url": _vm.apiUrl,
                            "can-edit": _vm.canEdit,
                          },
                        }),
                      ]
                    },
                  },
                  {
                    key: "table-busy",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "text-center text-danger my-2" },
                          [
                            _c("b-spinner", { staticClass: "align-middle" }),
                            _vm._v(" "),
                            _c("strong", [_vm._v("Lade Resteliste...")]),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _c("template", { slot: "top-row" }, [
                  _c(
                    "td",
                    { staticClass: "d-none d-md-table-cell" },
                    [
                      _c("b-form-select", {
                        attrs: {
                          size: "sm",
                          options: _vm.filterOptions.ingredient_categories,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "first",
                            fn: function () {
                              return [
                                _c(
                                  "b-form-select-option",
                                  { attrs: { value: "" } },
                                  [_vm._v("---")]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.filters.ingredient_category,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "ingredient_category", $$v)
                          },
                          expression: "filters.ingredient_category",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { attrs: { id: "ingredient-filter" } },
                    [
                      _c("b-form-input", {
                        attrs: {
                          size: "sm",
                          placeholder: "Zutat suchen...",
                          debounce: "200",
                        },
                        model: {
                          value: _vm.filters.ingredient_title,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "ingredient_title", $$v)
                          },
                          expression: "filters.ingredient_title",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "d-none d-md-table-cell" },
                    [
                      _c("b-form-input", {
                        staticClass: "amount-input",
                        attrs: { size: "sm", debounce: "200" },
                        model: {
                          value: _vm.filters.amount_available,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "amount_available", $$v)
                          },
                          expression: "filters.amount_available",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "td",
                    { staticClass: "d-none d-md-table-cell" },
                    [
                      _c("b-form-input", {
                        staticClass: "base-unit-input",
                        attrs: { size: "sm", debounce: "200" },
                        model: {
                          value: _vm.filters.base_unit_title,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "base_unit_title", $$v)
                          },
                          expression: "filters.base_unit_title",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("td", { staticClass: "d-none d-md-table-cell" }, [
                    _vm._v(" "),
                  ]),
                ]),
                _vm._v(" "),
                _vm._v(" "),
                _vm._v(" "),
                _vm._v(" "),
                _vm._v(" "),
                _vm.canEdit
                  ? _c("template", { slot: "bottom-row" }, [
                      _c("td", { staticClass: "d-none d-md-table-cell" }, [
                        _c("strong", [_vm._v("Eintrag hinzufügen:")]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c("v-multiselect", {
                            attrs: {
                              options: _vm.filteredIngredients,
                              "track-by": "value",
                              label: "text",
                              "show-labels": false,
                              searchable: true,
                              disabled: _vm.isSaving,
                            },
                            model: {
                              value: _vm.newItem.ingredient,
                              callback: function ($$v) {
                                _vm.$set(_vm.newItem, "ingredient", $$v)
                              },
                              expression: "newItem.ingredient",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "b-input-group",
                            {
                              staticClass: "d-md-none",
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "append",
                                    fn: function () {
                                      return [
                                        _c("b-input-group-text", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.newItem.ingredient
                                                ? _vm.newItem.ingredient
                                                    .base_unit_title
                                                : ""
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "b-btn",
                                          {
                                            staticClass: "d-sm-none",
                                            attrs: {
                                              size: "xs",
                                              variant: "primary",
                                              disabled: _vm.isSaving,
                                            },
                                            on: { click: _vm.createItem },
                                          },
                                          [
                                            !_vm.isSaving
                                              ? _c("i", {
                                                  staticClass: "fas fa-save",
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.isSaving
                                              ? _c("b-spinner", {
                                                  attrs: {
                                                    small: "",
                                                    variant: "light",
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(
                                              "\n                Hinzufügen\n              "
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                1389839641
                              ),
                            },
                            [
                              _vm._v(" "),
                              _c("b-form-input", {
                                staticClass: "amount-input",
                                attrs: {
                                  type: "number",
                                  size: "sm",
                                  placeholder: "Menge",
                                  step: Math.pow(
                                    10,
                                    (_vm.newItem.ingredient
                                      ? _vm.newItem.ingredient
                                          .base_unit_precision
                                      : 1) * -1
                                  ),
                                },
                                nativeOn: {
                                  keydown: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.createItem.apply(null, arguments)
                                  },
                                },
                                model: {
                                  value: _vm.newItem.amount,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.newItem, "amount", $$v)
                                  },
                                  expression: "newItem.amount",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-form-input", {
                            staticClass: "amount-input d-none d-md-block",
                            attrs: {
                              type: "number",
                              size: "sm",
                              placeholder: "Menge",
                              step: Math.pow(
                                10,
                                (_vm.newItem.ingredient
                                  ? _vm.newItem.ingredient.base_unit_precision
                                  : 1) * -1
                              ),
                            },
                            nativeOn: {
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.createItem.apply(null, arguments)
                              },
                            },
                            model: {
                              value: _vm.newItem.amount,
                              callback: function ($$v) {
                                _vm.$set(_vm.newItem, "amount", $$v)
                              },
                              expression: "newItem.amount",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("td", { staticClass: "d-none d-md-table-cell" }, [
                        _vm._v(
                          _vm._s(
                            _vm.newItem.ingredient
                              ? _vm.newItem.ingredient.base_unit_title
                              : ""
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "d-none d-md-table-cell" },
                        [
                          _c(
                            "b-btn",
                            {
                              staticClass: "save-row-toggle",
                              attrs: {
                                size: "xs",
                                variant: "primary",
                                disabled: _vm.isSaving,
                              },
                              on: { click: _vm.createItem },
                            },
                            [
                              !_vm.isSaving
                                ? _c("i", { staticClass: "fas fa-save" })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isSaving
                                ? _c("b-spinner", {
                                    attrs: { small: "", variant: "light" },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }